import React from 'react';
import { styled } from '@compiled/react';
import { Card, CardAction } from '@atlaskit/smart-card';
import { token } from '@atlaskit/tokens';
import type { CompassSmartLinkProps } from './types.tsx';

/**
 * An inline smart link intended for Compass links.
 */
export const CompassSmartLink = ({ url }: CompassSmartLinkProps) => {
	const handleClick = (event: React.MouseEvent | React.KeyboardEvent) => {
		event.preventDefault();
		// Open smart link in new tab by default, as it takes the user out of Jira

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.open(url, '_blank', 'noopener');
	};

	return (
		<SmartLinkStyleOverrides>
			<Card
				appearance="inline"
				url={url}
				showHoverPreview={false}
				onClick={handleClick}
				actionOptions={{
					hide: false,
					exclude: [CardAction.ChangeStatusAction],
				}}
			/>
		</SmartLinkStyleOverrides>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SmartLinkStyleOverrides = styled.div({
	/* Remove shadow "border" around link (if resolved) */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: {
		boxShadow: 'none',
	},
	/* Remove shadow "border" around link (edge states) */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"span[data-testid='inline-card-unauthorized-view'], span[data-testid='inline-card-not-found-view'], span[data-testid='inline-card-forbidden-view']":
		{
			boxShadow: 'none',
		},
	/* Hide the tier lozenge in resolved view */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"span[data-testid='inline-card-resolved-view-lozenge']": {
		display: 'none',
	},
	/* Replace resolved icon with Compass logo */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"img[data-testid='inline-card-icon-and-title-image']": {
		height: '16px',
		width: '16px',
		content: "url('https://compass-ui.prod-east.frontend.public.atl-paas.net/assets/compass.svg')",
	},
	/* Add spacing between icon and smart link title */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'span .smart-link-title-wrapper': {
		marginLeft: token('space.100'),
	},
});
